import React from 'react';
import {observer} from "mobx-react";
import {BaseMatchedTransaction} from "../../../model/MatchedDocument";
import {
    Alert,
    AlertTitle,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import {ResultOrErrorDto} from "../../../model/ResultOrErrorDto";

interface IProps {
    show: boolean,
    selectedItems: BaseMatchedTransaction[],
    sendItem: (tx: BaseMatchedTransaction) => Promise<ResultOrErrorDto<boolean>>,
    onClose: (success: boolean) => any,
}

interface IState {
    canCloseModal: boolean,
    current?: BaseMatchedTransaction,
    error: boolean,
    errorMessage?: string,
    sentCount: number,
}

class SendTransactionsModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            canCloseModal: false,
            sentCount: 0,
            error: false,
        };
    }

    componentDidMount() {
    }

    render() {
        const {sentCount, canCloseModal, current, error, errorMessage} = this.state;
        return <>
            <Dialog
                    onClose={this.closeModal}
                    aria-labelledby="customized-dialog-title"
                    open={this.props.show}
                    fullWidth={true}
                    maxWidth={'md'}
                    disableEscapeKeyDown={!canCloseModal}
                    TransitionProps={{
                        onEnter: this.startSending
                    }}>
                <DialogTitle id="customized-dialog-title">
                    Sending transaction in progress
                </DialogTitle>
                <DialogContent dividers>
                    <LinearProgress variant="determinate" value={sentCount}/>
                    {current &&
                            this.renderTxInfo(current)
                    }
                    {error &&
                            <Alert severity='error'>
                                <AlertTitle><Typography variant={"subtitle1"}>Failed to send current transaction!</Typography></AlertTitle>
                                <Typography variant={"subtitle2"}>{errorMessage ?? "Error is unknown"}</Typography></Alert>
                        }
                        {canCloseModal && !error &&
                                <Alert severity='success'>All transactions sent. You can close this dialog now.</Alert>
                        }
                </DialogContent>
                <DialogActions>
                    <Button autoFocus disabled={!canCloseModal} onClick={this.closeModal} variant="contained"
                            color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>;
    }

    private renderTxInfo(current: BaseMatchedTransaction) {
        const tx = current.tx;
        return <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell align="right">Desc</TableCell>
                            <TableCell align="right">Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {tx.txDate.toLocaleDateString()}
                            </TableCell>
                            <TableCell align="right">{tx.description}</TableCell>
                            <TableCell align="right">{tx.amount} {tx.currency}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    }

    startSending = async () => {
        const txs = this.props.selectedItems;
        const length = txs.length;
        for (let i = 0; i < length; i++) {
            let tx = txs[i];
            const sentCount = i / length * 100;
            this.setState({
                sentCount: sentCount,
                current: tx,
            });
            const doneOrError = await this.props.sendItem(tx);
            if (!doneOrError.result || doneOrError.error) {
                this.setState({
                    error: true,
                    errorMessage: doneOrError.error,
                    canCloseModal: true,
                });
                return;
            }
        }
        this.setState({
            canCloseModal: true,
            sentCount: 100,
        });
    };

    private resetState() {
        this.setState({
            canCloseModal: false,
            sentCount: 0,
            error: false,
            errorMessage: undefined,
        })
    }

    closeModal = () => {
        this.props.onClose(!this.state.error);
        this.resetState();
    };

}

export default observer(SendTransactionsModal);